class Role {
    constructor(serverRole) {
        this.serverRole = serverRole;
    }

    translate(t) {
        return t(`users.role-names.${this.serverRole.toLowerCase().replace(/_/g, '-')}`);
    }
}

export const ADMISSION = new Role('ADMISSION');

export const AUCTIONEER = new Role('AUCTIONEER');

export const BIDDER = new Role('BIDDER');

export const BID_AS_BROKER = new Role('BID_AS_BROKER');

export const CLEARING = new Role('CLEARING');

export const CLEARING_API_USER = new Role('CLEARING_API_USER');

export const COMPANY_VIEW_USER = new Role('COMPANY_VIEW_USER');

export const DATA_VENDOR_API_USER = new Role('DATA_VENDOR_API_USER');

export const EXTERNAL_ADMIN = new Role('EXTERNAL_ADMIN');

export const MARKET_SUPERVISION = new Role('MARKET_SUPERVISION');

export const MARKET_SURVEILLANCE = new Role('MARKET_SURVEILLANCE');

export const ENERGY_OPERATIONS = new Role('ENERGY_OPERATIONS');

export const TRADING_API_USER = new Role('TRADING_API_USER');

export const VIEW_ONLY_USER = new Role('VIEW_ONLY_USER');

export const SUPERADMIN = new Role('SUPERADMIN');

export const TECHNICAL_UPLOADER = new Role('TECHNICAL_UPLOADER');

export const getRole = (serverRole) => {
    let result = null;
    switch (serverRole) {
        case 'ADMISSION':
            result = ADMISSION;
            break;
        case 'AUCTIONEER':
            result = AUCTIONEER;
            break;
        case 'BIDDER':
            result = BIDDER;
            break;
        case 'BID_AS_BROKER':
            result = BID_AS_BROKER;
            break;
        case 'CLEARING':
            result = CLEARING;
            break;
        case 'CLEARING_API_USER':
            result = CLEARING_API_USER;
            break;
        case 'COMPANY_VIEW_USER':
            result = COMPANY_VIEW_USER;
            break;
        case 'DATA_VENDOR_API_USER':
            result = DATA_VENDOR_API_USER;
            break;
        case 'EXTERNAL_ADMIN':
            result = EXTERNAL_ADMIN;
            break;
        case 'MARKET_SUPERVISION':
            result = MARKET_SUPERVISION;
            break;
        case 'MARKET_SURVEILLANCE':
            result = MARKET_SURVEILLANCE;
            break;
        case 'ENERGY_OPERATIONS':
            result = ENERGY_OPERATIONS;
            break;
        case 'TRADING_API_USER':
            result = TRADING_API_USER;
            break;
        case 'VIEW_ONLY_USER':
            result = VIEW_ONLY_USER;
            break;
        case 'SUPERADMIN':
            result = SUPERADMIN;
            break;
        case  'TECHNICAL_UPLOADER':
            result = TECHNICAL_UPLOADER;
            break;
        default:
            throw new Error(`Unknown role: ${serverRole}`);
    }
    return result;
};

export const getAllRoles = () => [
    ADMISSION,
    AUCTIONEER,
    BIDDER,
    BID_AS_BROKER,
    CLEARING,
    CLEARING_API_USER,
    COMPANY_VIEW_USER,
    DATA_VENDOR_API_USER,
    EXTERNAL_ADMIN,
    MARKET_SUPERVISION,
    MARKET_SURVEILLANCE,
    ENERGY_OPERATIONS,
    TRADING_API_USER,
    VIEW_ONLY_USER,
    SUPERADMIN,
];

export const createRoleItem = (t, role) => ({
    id: role,
    label: getRole(role).translate(t),
});

export const handleBrokerWithBidder = (oldRoles, newRoles) => {
    let newRolesToSet = [...newRoles];
    if (newRoles.includes('BID_AS_BROKER') && !newRoles.includes('BIDDER')) {
        if (oldRoles.includes('BIDDER')) {
            // deselecting of bidder => deselect also bid as broker
            newRolesToSet = newRoles.filter((oldRole) => oldRole !== 'BID_AS_BROKER');
        } else {
            // adding bid as broker => add also bidder
            newRolesToSet.push('BIDDER');
        }
    }
    return newRolesToSet;
};
